// extracted by mini-css-extract-plugin
export default {"storyCta":"x2QkvS4h3DV3VAaoCuMg"};